import commonConfig from '../../config/commonConfig';
const knowConfig = {
  svcHosts: process.env.PUBLIC_URL,
  svcHost: commonConfig.svcHost,
  svcHostEnv: process.env.REACT_APP_API_HOST,

  getKnowData: {
    method: 'GET',
    url: '/accreditation/wealth/v1/question/61/',
    timeout: 30000,
  },
  getKnowResult: {
    method: 'GET',
    url: '/accreditation/wealth/v1/result/',
    timeout: 30000,
  },
  saveKnowData: {
    method: 'POST',
    url: '/accreditation/wealth/v1/question/responses',
    timeout: 30000,
  },
  updateKnowData: {
    method: 'PUT',
    url: '/accreditation/wealth/v1/result/responses',
    timeout: 30000,
  },
  uploadCertificateFile: {
    method: 'UPLOAD',
    url: '/accreditation/wealth/v1/file/upload',
    timeout: 30000,
  },
  downloadFile: {
    method: 'GET',
    url: '/accreditation/wealth/v1/result/doc/',
    timeout: 30000,
  },
  getKnowScores: {
    method: 'POST',
    url: '/accreditation/wealth/v1/result/scores',
    timeout: 30000,
  },
};

export default knowConfig;
